import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'

export function createCustomerType(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
) {
  return {
    ...generateBaseEntity(EntityTypeEnum.CustomerType, parentId, masterBlockId),
  }
}
